// 应用配置文件
export const appConfig = {
  // 权限控制配置
  permissions: {
    // 是否允许成员编辑功能
    // 开发环境: 始终允许
    // 生产环境: 可以在这里直接修改为 true 来启用编辑
    allowMemberEditing: {
      development: true,  // 开发环境始终允许
      production: false   // 生产环境默认禁止，需要时改为 true
    },

    // 临时启用编辑的URL参数名
    adminParamName: 'admin',

    // 临时启用编辑的参数值
    adminParamValue: 'true'
  },
  
  // API 配置
  api: {
    // 基础URL会根据环境自动设置
    baseURL: import.meta.env.MODE === 'development' 
      ? 'http://localhost:3001' 
      : '/api'
  },
  
  // 数据同步配置
  sync: {
    // 自动刷新间隔（毫秒）
    autoRefreshInterval: 5 * 60 * 1000, // 5分钟
    
    // 同步超时时间（毫秒）
    syncTimeout: 30 * 1000 // 30秒
  },
  
  // UI 配置
  ui: {
    // 每页显示的成员数量
    membersPerPage: 50,
    
    // 是否显示调试信息
    showDebugInfo: import.meta.env.MODE === 'development'
  }
}

// 权限检查函数
export const checkEditingPermission = () => {
  const currentMode = import.meta.env.MODE

  // 1. 根据当前环境检查配置
  const modeConfig = appConfig.permissions.allowMemberEditing[currentMode]
  if (modeConfig === true) {
    return true
  }

  // 2. 检查URL参数临时启用
  const urlParams = new URLSearchParams(window.location.search)
  const adminParam = urlParams.get(appConfig.permissions.adminParamName)
  if (adminParam === appConfig.permissions.adminParamValue) {
    return true
  }

  // 3. 默认禁止
  return false
}

// 获取当前环境信息
export const getEnvironmentInfo = () => {
  return {
    mode: import.meta.env.MODE,
    isDevelopment: import.meta.env.MODE === 'development',
    isProduction: import.meta.env.MODE === 'production',
    editingAllowed: checkEditingPermission()
  }
}
